import { SetupProviderFormState } from '@Forms/providers/SetupProviderFormContext';
import { UpdateRequest } from '@contracts/api/dto/common/UpdateRequest';
import { ProviderItemDto } from '@contracts/api/dto/providers/ProviderDto';

export const useSetupProviderUseCaseMapper = (provider: ProviderItemDto) => {
  return {
    toFormState: async (providerId: string): Promise<SetupProviderFormState | undefined> => {
      return {
        name: provider?.name,
        apiUrl: provider?.apiUrl,
        syncRoundEnd: provider?.syncRoundEnd,
        status: provider?.status,
        retryScheduledSendCredit: provider?.retryScheduledSendCredit,
        refundOnCreditFail: provider?.refundOnCreditFail,
        filterExternalProviderBets: provider?.filterExternalProviderBets,
        isInternal: provider?.isInternal,
        integrationType: provider?.integrationType,
        syncRaindrop: provider?.syncRaindrop,
        syncFreebet: provider?.syncFreebet,
        notifyOnLastFreebet: provider?.notifyOnLastFreebet,
        enableInactivityScreen: provider?.enableInactivityScreen,
        raindropType: provider?.raindropType,
      };
    },
    toDto: (formState: SetupProviderFormState): UpdateRequest<SetupProviderFormState> => {
      // @ts-ignore
      return {
        body: {
          name: formState.name,
          apiUrl: formState.apiUrl,
          syncRoundEnd: formState.syncRoundEnd,
          status: formState.status,
          retryScheduledSendCredit: formState.retryScheduledSendCredit,
          refundOnCreditFail: formState.refundOnCreditFail,
          filterExternalProviderBets: formState.filterExternalProviderBets,
          isInternal: formState.isInternal,
          integrationType: formState.integrationType,
          syncRaindrop: formState.syncRaindrop,
          syncFreebet: formState.syncFreebet,
          notifyOnLastFreebet: formState.notifyOnLastFreebet,
          enableInactivityScreen: formState.enableInactivityScreen,
          raindropType: formState.raindropType,
        },
      };
    },
  };
};
